export const UNAUTHORIZED_IMAGE_URL =
  'https://s3-ap-southeast-1.amazonaws.com/static.shoplineapp.com/tmp/dashboard-ui/unauthorized.svg';
